import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import {
  Grid,
  TextField,
} from "@material-ui/core";
import {
  getGasMovementsRequests,
  saveStation,
} from "redux/actions/gasMovementsRequests/gasMovementsRequestActions";
import RegularButton from "components/CustomButtons/Button";
import { Autocomplete } from "@material-ui/lab";
import { useSearch } from "hooks/useSearch";
import { newDate } from "helpers/dateTools";
import { dateValidator } from "helpers/dateValidator";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const SearchStation = () => {
  const { stationsList } = useSelector(({ companies }) => companies);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { station } = useSelector(
    ({ gasMovementsRequests }) => gasMovementsRequests
  );
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const { setSnackbar } = useSearch();
  const currentDate = new Date();
  const maxDate = new Date();
  maxDate.setDate(currentDate.getDate());

  const maxDateString = maxDate.toISOString().split("T")[0];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    if (!station) {
      setSnackbar("Por favor, selecciona la estación");
      return;
    }
    dispatch(getGasMovementsRequests(startDate, endDate, station?.id));
  };

  const handleStartDate = ({ target }) => {
    setStartDate(target.value);
  };

  const handleEndDate = ({ target }) => {
    setEndDate(target.value);
  };
  const handleChange = (v) => {
    dispatch(saveStation(v));
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        padding: 4,
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3} style={style}>
          <TextField
            label="Desde"
            type="date"
            name="startDate"
            value={startDate}
            variant="outlined"
            fullWidth
            required={true}
            onChange={handleStartDate}
            size="small"
            inputProps={{
              max: maxDateString,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={3} style={style}>
          <TextField
            label="Hasta"
            type="date"
            name="endDate"
            value={endDate}
            variant="outlined"
            fullWidth
            onChange={handleEndDate}
            size="small"
            inputProps={{
              max: newDate({
                diffDays: 1
              }),
            }}
          />
        </Grid>

        <Grid item xs={12} sm={3} style={style}>
          <Autocomplete
            id="combo-box-demo"
            options={stationsList}
            getOptionLabel={(option) =>
              option.label || ''
            }
            value={station}
            renderInput={(params) => (
              <TextField
                {...params}
                value={station}
                name="station"
                label="Planta"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={(e, v) => handleChange(v)}
            noOptionsText="No se encuentra la planta"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={1}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RegularButton color="info" onClick={handleSubmit} fullWidth loading={isLoadingComp?.GM_RequestsLoading}>
            buscar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
